
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    getModules,
    fetchSubscriptionPlans,
    saveModules,
} from "../../../Servicefile/moduleService.jsx";
const SubscriptionTable = () => {
    const [selectedModules, setSelectedModules] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [modulePrices, setModulePrices] = useState({});
    const [showAddModulePopup, setShowAddModulePopup] = useState(false);
    const [modulesData, setModulesData] = useState([]);
    const [newModule, setNewModule] = useState({
        code: '',
        description: '',
        monthlyPrice: 0,
        yearlyPrice: 0,
        subscriptionPrice: 0,
        defaultIncluded: 'INCLUDE',
        catageory: 'BASE_PLAN'
    });
    const [editingModules, setEditingModules] = useState({});
    const [loading, setLoading] = useState(false);
    const [authToken, setAuthToken] = useState('');
    const [defaultIncludedOptions] = useState([
        { value: 'INCLUDE', label: 'Include' },
        { value: 'MANDATORY', label: 'Mandatory' },
        { value: 'EXCLUDE', label: 'Exclude' }
    ]);
    const [categoryOptions] = useState([
        { value: 'BASE_PLAN', label: 'Base Platform' },
        { value: 'FEATURE_ADD_ON', label: 'Feature Add-on' },
        { value: 'ORDER_TYPE', label: 'Order Type' },
        { value: 'ORDERTYPE_ADD_ON', label: 'Order Type Add-on' },
        { value: 'SUBSCRIPTION', label: 'Subscription' },
        { value: 'COMMISSION', label: 'Commission' }
    ]);

    // API Configuration
    const API_BASE_URL = 'https://backend.maamaas.com/subscription/api';
    const planType = 'STANDARD';
    const businessVertical = 'FOOD_AND_BEVERAGES';

    // Category display mapping
    const categoryDisplayNames = {
        'BASE_PLAN': 'Base Platform',
        'FEATURE_ADD_ON': 'Feature (Add-on)',
        'ORDER_TYPE': 'Order Type',
        'ORDERTYPE_ADD_ON': 'Order Type (Add-on)'
    };

    // Category order for sorting
    const categoryOrder = {
        'BASE_PLAN': 1,
        'ORDER_TYPE': 2,
        'FEATURE_ADD_ON': 3,
        'ORDERTYPE_ADD_ON': 4
    };

    // Get auth token from localStorage or cookies
    useEffect(() => {
        const token = localStorage.getItem('authToken') ||
            localStorage.getItem('token') ||
            sessionStorage.getItem('authToken') ||
            sessionStorage.getItem('token');

        if (token) {
            setAuthToken(token);
        } else {
            console.warn('No authentication token found. API requests may fail.');
        }
    }, []);

    // Fetch modules data on component mount
    useEffect(() => {
        fetchModulesData();
    }, [authToken]);

    const fetchModulesData = async () => {

        try {

            setLoading(true);

            const result = await fetchSubscriptionPlans(
                planType,
                businessVertical,
                authToken
            );

            if (result.success && result.data?.modules) {

                const modules = result.data.modules;

                console.log("API Response:", result.data);
                console.log("Modules from API:", modules);

                // Sort modules by ID
                const sortedModules = [...modules].sort(
                    (a, b) => {
                        const idA = a.id || 999999;
                        const idB = b.id || 999999;

                        return idA - idB;
                    }
                );

                const transformedModules =
                    transformApiDataToTableFormat(
                        sortedModules
                    );

                setModulesData(transformedModules);

                const selectedState = {};
                const priceState = {};
                const editState = {};

                sortedModules.forEach((module) => {

                    if (
                        module.defaultIncluded === "TOGGLE" ||
                        (
                            module.defaultIncluded !== "MANDATORY" &&
                            module.defaultIncluded !== "INCLUDE" &&
                            module.defaultIncluded !== "EXCLUDE"
                        )
                    ) {
                        selectedState[module.code] = true;
                    }

                    priceState[module.code] = {
                        monthly: module.monthlyPrice,
                        yearly: module.yearlyPrice,
                        subscriptionPrice:
                            module.subscriptionPrice,
                        id: module.id,
                    };

                    editState[module.code] = {
                        name: formatModuleName(module.code),
                        description: module.description,
                        monthlyPrice: module.monthlyPrice,
                        yearlyPrice: module.yearlyPrice,
                        subscriptionPrice:
                            module.subscriptionPrice || 0,
                        defaultIncluded:
                            module.defaultIncluded || "INCLUDE",
                        catageory:
                            module.catageory ||
                            module.category ||
                            "BASE_PLAN",
                    };
                });

                setSelectedModules(selectedState);
                setModulePrices(priceState);
                setEditingModules(editState);

            } else {

                if (result.status === 403) {

                    alert(
                        "Authentication required. Please login first."
                    );

                } else {

                    alert(
                        result.message ||
                        "Failed to load modules data"
                    );
                }
            }

        } catch (error) {

            console.error(
                "Fetch Modules Error:",
                error
            );

            alert("Something went wrong");

        } finally {

            setLoading(false);
        }
    };

    const transformApiDataToTableFormat = (apiModules) => {
        const transformed = [];

        console.log('Transforming API modules:', apiModules);

        // Track which categories we've seen
        const categoriesSeen = new Set();

        apiModules.forEach((module) => {
            let type;

            const apiCategory = module.catageory || module.category || 'BASE_PLAN';

            // ✅ FIX: Show category only for first occurrence of each category
            let category = '';
            if (!categoriesSeen.has(apiCategory)) {
                category = categoryDisplayNames[apiCategory] || apiCategory;
                categoriesSeen.add(apiCategory);
            }

            if (module.defaultIncluded === 'MANDATORY') {
                type = 'mandatory';
            } else if (module.defaultIncluded === 'INCLUDE') {
                type = 'included';
            } else if (module.defaultIncluded === 'EXCLUDE') {
                type = 'exclude';
            } else {
                type = 'toggle';
            }

            transformed.push({
                category: category,
                rawCategory: apiCategory,
                name: formatModuleName(module.code),
                code: module.code,
                description: module.description,
                type: type,
                monthlyPrice: module.monthlyPrice,
                yearlyPrice: module.yearlyPrice,
                subscriptionPrice: module.subscriptionPrice || 0,
                apiId: module.id,
                defaultIncluded: module.defaultIncluded || 'INCLUDE',
                apiCatageory: apiCategory,
                id: module.id || 999999
            });
        });

        // Sort by category order and then by ID
        transformed.sort((a, b) => {
            // First sort by category order
            const categoryOrderA = categoryOrder[a.rawCategory] || 999;
            const categoryOrderB = categoryOrder[b.rawCategory] || 999;

            if (categoryOrderA !== categoryOrderB) {
                return categoryOrderA - categoryOrderB;
            }

            // Then sort by ID within same category
            return (a.id || 999999) - (b.id || 999999);
        });

        console.log('Transformed result:', transformed);
        return transformed;
    };

    const formatModuleName = (code) => {
        return code.toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Get available module codes (filter out already added modules)
    const getAvailableModuleCodes = () => {
        const addedCodes = modulesData.map(module => module.code);

        const allCodes = [
            'PLATFORM_ACCESS', 'VENDOR_PROFILE', 'MENU_MANAGEMENT',
            'ORDER_MANAGEMENT', 'TABLE_ORDERS', 'DELIVERY', 'CATERING',
            'INVENTORY_MANAGEMENT', 'CHEF_MANAGEMENT', 'TEAM_MANAGEMENT',
            'PROMOTIONS', 'REPORTS', 'PAYOUTS', 'SUPPORT',
            'WALLETS', 'ACCOUNT_HISTORY', 'NOTIFICATIONS', 'COUPONS_OFFERS',
            'DINE_IN', 'TAKEAWAY', 'SETTINGS_CONTROLS', 'SUBSCRIPTION', 'REGISTRATION', 'SALES_MANAGEMENT'
        ];

        return allCodes.filter(code => !addedCodes.includes(code));
    };

    const handleModuleToggle = (moduleCode) => {
        setSelectedModules(prev => ({
            ...prev,
            [moduleCode]: !prev[moduleCode]
        }));
    };

    const handleEditClick = () => {
        setIsEditing(!isEditing);
        if (!isEditing) {
            const editState = {};
            modulesData.forEach(module => {
                editState[module.code] = {
                    name: module.name,
                    description: module.description,
                    monthlyPrice: module.monthlyPrice,
                    yearlyPrice: module.yearlyPrice,
                    subscriptionPrice: module.subscriptionPrice || 0,
                    defaultIncluded: module.defaultIncluded || 'INCLUDE',
                    catageory: module.apiCatageory || 'BASE_PLAN'
                };
            });
            setEditingModules(editState);
        }
    };

    const handlePriceChange = (moduleCode, field, value) => {
        setEditingModules(prev => ({
            ...prev,
            [moduleCode]: {
                ...prev[moduleCode],
                [field]: field.includes('Price') ? parseFloat(value) || 0 : value
            }
        }));
    };

    const handleSaveChanges =
        async () => {

            try {

                setLoading(true);

                const updatedModules =
                    modulesData.map((module) => {

                        const editData =
                            editingModules[
                            module.code
                            ];

                        return {
                            id:
                                module.apiId || 0,

                            code: module.code,

                            description:
                                editData
                                    ? editData.description
                                    : module.description,

                            defaultIncluded:
                                editData
                                    ? editData.defaultIncluded
                                    : module.defaultIncluded ||
                                    "INCLUDE",

                            monthlyPrice:
                                editData
                                    ? editData.monthlyPrice
                                    : module.monthlyPrice,

                            yearlyPrice:
                                editData
                                    ? editData.yearlyPrice
                                    : module.yearlyPrice,

                            subscriptionPrice:
                                editData
                                    ? editData.subscriptionPrice
                                    : module.subscriptionPrice,

                            catageory:
                                editData
                                    ? editData.catageory
                                    : module.apiCatageory ||
                                    "BASE_PLAN",
                        };
                    });

                // 🔥 SERVICE API
                await saveModules(
                    businessVertical,
                    planType,
                    updatedModules,
                    authToken
                );

                setIsEditing(false);

                alert(
                    "Changes saved successfully!"
                );

                fetchModulesData();

            } catch (error) {

                console.error(
                    "Error saving changes:",
                    error
                );

                if (
                    error.response?.status === 403
                ) {

                    alert(
                        "Access denied. Please check your permissions or login again."
                    );

                } else {

                    alert(
                        `Failed to save changes: ${error.response?.data
                            ?.message ||
                        error.message
                        }`
                    );
                }

            } finally {

                setLoading(false);
            }
        };

    const handleAddModule = () => {
        setShowAddModulePopup(true);
        setNewModule({
            code: '',
            description: '',
            monthlyPrice: 0,
            yearlyPrice: 0,
            defaultIncluded: 'INCLUDE',
            catageory: 'BASE_PLAN'
        });
    };

    const handleSaveNewModule =
        async () => {

            try {

                // VALIDATION
                if (
                    !newModule.code ||
                    !newModule.description
                ) {

                    alert(
                        "Please fill in all required fields"
                    );

                    return;
                }

                setLoading(true);

                // NEW MODULE OBJECT
                const moduleToAdd = {
                    code: newModule.code,

                    description:
                        newModule.description,

                    monthlyPrice:
                        parseFloat(
                            newModule.monthlyPrice
                        ) || 0,

                    yearlyPrice:
                        parseFloat(
                            newModule.yearlyPrice
                        ) || 0,

                    subscriptionPrice:
                        parseFloat(
                            newModule.subscriptionPrice
                        ) || 0,

                    defaultIncluded:
                        newModule.defaultIncluded,

                    catageory:
                        newModule.catageory,
                };

                // EXISTING MODULES
                const existingModules =
                    modulesData.map((module) => {

                        const moduleData = {
                            code: module.code,

                            description:
                                module.description,

                            defaultIncluded:
                                module.defaultIncluded ||
                                "INCLUDE",

                            monthlyPrice:
                                module.monthlyPrice,

                            yearlyPrice:
                                module.yearlyPrice,

                            subscriptionPrice:
                                module.subscriptionPrice || 0,

                            catageory:
                                module.apiCatageory ||
                                "BASE_PLAN",
                        };

                        // ADD ID IF EXISTS
                        if (
                            module.apiId &&
                            module.apiId !== 0
                        ) {

                            moduleData.id =
                                module.apiId;
                        }

                        return moduleData;
                    });

                // DUPLICATE CHECK
                if (
                    existingModules.some(
                        (m) =>
                            m.code ===
                            moduleToAdd.code
                    )
                ) {

                    alert(
                        "Module with this code already exists!"
                    );

                    return;
                }

                // FINAL MODULE ARRAY
                const allModules = [
                    ...existingModules,
                    moduleToAdd,
                ];

                console.log(
                    "Adding new module:",
                    allModules
                );

                // 🔥 SERVICE API CALL
                const response =
                    await saveModules(
                        businessVertical,
                        planType,
                        allModules,
                        authToken
                    );

                console.log(
                    "Add module response:",
                    response
                );

                // CLOSE POPUP
                setShowAddModulePopup(
                    false
                );

                alert(
                    "Module added successfully!"
                );

                // REFRESH DATA
                fetchModulesData();

            } catch (error) {

                console.error(
                    "Error adding module:",
                    error
                );

                console.error(
                    "Error details:",
                    error.response?.data ||
                    error.message
                );

                // AUTH ERROR
                if (
                    error.response?.status === 403
                ) {

                    alert(
                        "Access denied. You need admin privileges to add modules."
                    );

                } else {

                    alert(
                        `Failed to add module: ${error.response?.data
                            ?.message ||
                        error.message
                        }`
                    );
                }

            } finally {

                setLoading(false);
            }
        };

    const calculateTotal = (period = 'monthly') => {
        let total = 0;

        modulesData.forEach(module => {
            if (module.type === 'mandatory' || module.type === 'included') {
                const price = isEditing && editingModules[module.code] ?
                    editingModules[module.code].monthlyPrice : module.monthlyPrice;
                const yearlyPrice = isEditing && editingModules[module.code] ?
                    editingModules[module.code].yearlyPrice : module.yearlyPrice;
                total += period === 'monthly' ? price : yearlyPrice;
            }
            else if (module.type === 'toggle' && selectedModules[module.code]) {
                const price = isEditing && editingModules[module.code] ?
                    editingModules[module.code].monthlyPrice : module.monthlyPrice;
                const yearlyPrice = isEditing && editingModules[module.code] ?
                    editingModules[module.code].yearlyPrice : module.yearlyPrice;
                total += period === 'monthly' ? price : yearlyPrice;
            }
        });

        return total;
    };

    const monthlyTotal = calculateTotal('monthly');
    const yearlyTotal = calculateTotal('yearly');

    const availableModules = getAvailableModuleCodes();
    const subscriptionTotal = modulesData.reduce(
        (total, module) =>
            total + Number(module.subscriptionPrice || 0),
        0
    );
    const popupStyles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10001
        },
        popup: {
            background: 'white',
            borderRadius: '8px',
            padding: '15px',
            width: '400px',
            maxWidth: '90%',
            maxHeight: '548px',
            overflowY: 'auto',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
        },
        title: {
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '12px',
            color: '#333'
        },
        formGroup: {
            marginBottom: '10px'
        },
        label: {
            display: 'block',
            marginBottom: '4px',
            fontSize: '12px',
            fontWeight: '500',
            color: '#555'
        },
        input: {
            width: '100%',
            padding: '6px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '13px',
            boxSizing: 'border-box'
        },
        select: {
            width: '100%',
            padding: '6px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '13px',
            backgroundColor: 'white',
            boxSizing: 'border-box'
        },
        buttonGroup: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '12px'
        },
        saveButton: {
            padding: '6px 12px',
            borderRadius: '4px',
            border: 'none',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            background: '#4CAF50',
            color: 'white',
            minWidth: '80px'
        },
        cancelButton: {
            padding: '6px 12px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            background: 'white',
            color: '#555',
            minWidth: '80px'
        },
        addButton: {
            padding: '14px 16px',
            borderRadius: '6px',
            border: 'none',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer',
            background: 'rgb(230 109 51)',
            color: 'white',
            marginBottom: '12px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
        },
        loginPrompt: {
            background: '#fff3cd',
            border: '1px solid #ffeaa7',
            padding: '10px',
            borderRadius: '4px',
            marginTop: '10px',
            fontSize: '12px',
            color: '#856404'
        },
        loginButton: {
            background: '#007bff',
            color: 'white',
            border: 'none',
            padding: '4px 8px',
            borderRadius: '3px',
            marginLeft: '5px',
            cursor: 'pointer',
            fontSize: '11px'
        }
    };

    const styles = {
        container: {
            maxWidth: '1011px',
            // margin: '0 auto',
            padding: '10px',
            // marginLeft: '40px',
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            minHeight: '100vh'
        },
        tableContainer: {
            background: 'white',
            borderRadius: '12px',
            overflow: 'auto',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
            marginBottom: '2rem'
        },
        tableHeader: {
            background: 'linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)',
            color: 'white'
        },
        headerCell: {
            padding: '1.25rem 1rem',
            textAlign: 'center',
            fontWeight: '600',
            fontSize: '0.95rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            borderRight: '1px solid rgba(255, 255, 255, 0.1)'
        },
        lastHeaderCell: {
            borderRight: 'none'
        },
        dataCell: {
            padding: '1rem',
            borderBottom: '1px solid #f1f5f9',
            verticalAlign: 'middle'
        },
        categoryCell: {
            fontWeight: '600',
            color: '#475569',
            fontSize: '0.95rem',
            backgroundColor: '#f8fafc',
            borderRight: '1px solid #f1f5f9'
        },
        moduleName: {
            fontWeight: '600',
            color: '#1e293b',
            marginBottom: '4px'
        },
        moduleNameInput: {
            width: '100%',
            padding: '8px',
            borderRadius: '4px',
            border: '2px solid #e2e8f0',
            fontSize: '0.95rem',
            fontWeight: '600',
            color: '#1e293b'
        },
        moduleDescription: {
            fontSize: '0.85rem',
            color: '#64748b',
            lineHeight: '1.4'
        },
        descriptionInput: {
            width: '100%',
            padding: '8px',
            borderRadius: '4px',
            border: '2px solid #e2e8f0',
            fontSize: '0.85rem',
            color: '#64748b'
        },
        statusCell: {
            textAlign: 'center',
            padding: '1rem'
        },
        toggleContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px'
        },
        toggleSwitch: {
            position: 'relative',
            display: 'inline-block',
            width: '68px',
            height: '34px'
        },
        toggleInput: {
            opacity: 0,
            width: 0,
            height: 0
        },
        toggleSlider: {
            position: 'absolute',
            cursor: 'pointer',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#cbd5e0',
            transition: '.4s',
            borderRadius: '34px'
        },
        toggleSliderBefore: {
            position: 'absolute',
            content: '""',
            height: '26px',
            width: '26px',
            left: '4px',
            bottom: '4px',
            backgroundColor: 'white',
            transition: '.4s',
            borderRadius: '50%',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
        },
        checkedToggleSlider: {
            backgroundColor: '#10b981'
        },
        checkedToggleSliderBefore: {
            transform: 'translateX(34px)'
        },
        toggleLabel: {
            fontSize: '0.85rem',
            fontWeight: '600',
            marginTop: '4px'
        },
        includedText: {
            color: '#10b981'
        },
        excludedText: {
            color: '#ef4444'
        },
        badge: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            borderRadius: '20px',
            fontSize: '0.85rem',
            fontWeight: '600'
        },
        mandatoryBadge: {
            background: '#fee2e2',
            color: '#dc2626',
            border: '1px solid #fecaca'
        },
        includedBadge: {
            background: '#d1fae5',
            color: '#059669',
            border: '1px solid #a7f3d0'
        },
        addonBadge: {
            background: '#e0f2fe',
            color: '#0369a1',
            border: '1px solid #bae6fd'
        },
        priceCell: {
            textAlign: 'center',
            padding: '1rem'
        },
        priceDisplay: {
            fontSize: '1rem',
            fontWeight: '600',
            color: '#059669'
        },
        includedPrice: {
            fontSize: '0.9rem',
            fontWeight: '500',
            color: '#64748b'
        },
        priceInput: {
            width: '100px',
            padding: '6px 8px',
            borderRadius: '4px',
            border: '2px solid #e2e8f0',
            fontSize: '1rem',
            fontWeight: '600',
            textAlign: 'center',
            color: '#059669',
            transition: 'all 0.3s ease'
        },
        tableFooter: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem',
            backgroundColor: '#f8fafc',
            borderTop: '1px solid #e2e8f0'
        },
        grandTotalRow: {
            backgroundColor: '#f0fdf4',
            borderTop: '2px solid #10b981'
        },
        grandTotalCell: {
            padding: '1.5rem 1rem',
            fontWeight: '700',
            fontSize: '1.1rem',
            color: '#065f46'
        },
        grandTotalLabel: {
            textAlign: 'left'
        },
        grandTotalAmount: {
            textAlign: 'center',
            fontSize: '1.2rem'
        },
        footerLeft: {
            flex: 1
        },
        footerRight: {
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        editButton: {
            padding: '10px 24px',
            borderRadius: '8px',
            border: 'none',
            fontSize: '0.95rem',
            fontWeight: '600',
            cursor: 'pointer',
            background: isEditing ? 'linear-gradient(135deg, #059669 0%, #10b981 100%)' : 'linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)',
            color: 'white',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        },
        saveCancelContainer: {
            display: 'flex',
            gap: '0.75rem'
        },
        saveButton: {
            padding: '10px 20px',
            borderRadius: '8px',
            border: 'none',
            fontSize: '0.95rem',
            fontWeight: '600',
            cursor: 'pointer',
            background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
            color: 'white',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 6px -1px rgba(5, 150, 105, 0.3)'
        },
        cancelButton: {
            padding: '10px 20px',
            borderRadius: '8px',
            border: '2px solid #e2e8f0',
            fontSize: '0.95rem',
            fontWeight: '600',
            cursor: 'pointer',
            background: 'white',
            color: '#64748b',
            transition: 'all 0.3s ease'
        },
        topControls: {
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: '0rem',
            padding: '0 0.5rem'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse'
        },
        loadingOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 100
        },
        authWarning: {
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '15px',
            color: '#856404',
            fontSize: '14px'
        }
    };

    if (loading && modulesData.length === 0) {
        return (
            <div style={styles.container}>
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                    Loading modules...
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            {showAddModulePopup && (
                <div style={popupStyles.overlay}>
                    <div style={popupStyles.popup}>
                        <h3 style={popupStyles.title}>Add New Module</h3>

                        {!authToken && (
                            <div style={popupStyles.loginPrompt}>
                                ⚠️ Admin access required. You need to be logged in as admin to add modules.
                                <button
                                    style={popupStyles.loginButton}
                                    onClick={() => {
                                        window.location.href = '/login';
                                    }}
                                >
                                    Login
                                </button>
                            </div>
                        )}

                        <div style={popupStyles.formGroup}>
                            <label style={popupStyles.label}>Module Code *</label>
                            <select
                                value={newModule.code}
                                onChange={(e) => setNewModule({ ...newModule, code: e.target.value })}
                                style={popupStyles.select}
                                disabled={!authToken}
                            >
                                <option value="">Select Module Code</option>
                                {availableModules.map(code => (
                                    <option key={code} value={code}>
                                        {formatModuleName(code)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={popupStyles.formGroup}>
                            <label style={popupStyles.label}>Default Included</label>
                            <select
                                value={newModule.defaultIncluded}
                                onChange={(e) => setNewModule({ ...newModule, defaultIncluded: e.target.value })}
                                style={popupStyles.select}
                                disabled={!authToken}
                            >
                                <option value="INCLUDE">Include</option>
                                <option value="MANDATORY">Mandatory</option>
                                <option value="EXCLUDE">Exclude</option>
                            </select>
                        </div>

                        <div style={popupStyles.formGroup}>
                            <label style={popupStyles.label}>Monthly Price (₹)</label>
                            <input
                                type="number"
                                value={newModule.monthlyPrice}
                                onChange={(e) => setNewModule({ ...newModule, monthlyPrice: e.target.value })}
                                style={{
                                    ...popupStyles.input,
                                    backgroundColor: newModule.defaultIncluded === 'INCLUDE' ? '#f0f0f0' : 'white'
                                }}
                                min="0"
                                step="1"
                                disabled={!authToken || newModule.defaultIncluded === 'INCLUDE'}
                                readOnly={newModule.defaultIncluded === 'INCLUDE'}
                            />
                        </div>

                        <div style={popupStyles.formGroup}>
                            <label style={popupStyles.label}>Yearly Price (₹)</label>
                            <input
                                type="number"
                                value={newModule.yearlyPrice}
                                onChange={(e) => setNewModule({ ...newModule, yearlyPrice: e.target.value })}
                                style={{
                                    ...popupStyles.input,
                                    backgroundColor: newModule.defaultIncluded === 'INCLUDE' ? '#f0f0f0' : 'white'
                                }}
                                min="0"
                                step="1"
                                disabled={!authToken || newModule.defaultIncluded === 'INCLUDE'}
                                readOnly={newModule.defaultIncluded === 'INCLUDE'}
                            />
                        </div>

                        <div style={popupStyles.formGroup}>
                            <label style={popupStyles.label}>Category *</label>
                            <select
                                value={newModule.catageory}
                                onChange={(e) => setNewModule({ ...newModule, catageory: e.target.value })}
                                style={popupStyles.select}
                                disabled={!authToken}
                            >
                                <option value="BASE_PLAN">Base Platform</option>
                                <option value="FEATURE_ADD_ON">Feature Add-on</option>
                                <option value="ORDER_TYPE">Order Type</option>
                                <option value="ORDERTYPE_ADD_ON">Order Type Add-on</option>
                                <option value="SUBSCRIPTION">Subscription</option>
                                <option value="COMMISSION">Commission</option>
                            </select>
                        </div>

                        <div style={popupStyles.formGroup}>
                            <label style={popupStyles.label}>Description *</label>
                            <input
                                type="text"
                                value={newModule.description}
                                onChange={(e) => setNewModule({ ...newModule, description: e.target.value })}
                                placeholder="App & system access"
                                style={popupStyles.input}
                                disabled={!authToken}
                            />
                        </div>

                        <div style={popupStyles.buttonGroup}>
                            <button
                                style={popupStyles.cancelButton}
                                onClick={() => setShowAddModulePopup(false)}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                style={{
                                    ...popupStyles.saveButton,
                                    opacity: !authToken ? 0.6 : 1,
                                    cursor: !authToken ? 'not-allowed' : 'pointer'
                                }}
                                onClick={handleSaveNewModule}
                                disabled={loading || !authToken}
                            >
                                {loading ? 'Adding...' : 'Add'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div style={styles.topControls}>
                {!authToken && (
                    <div style={styles.authWarning}>
                        ⚠️ Read-only mode. Login with admin account to edit or add modules.
                    </div>
                )}
                <button
                    style={{
                        ...popupStyles.addButton,
                        opacity: !authToken ? 0.6 : 1,
                        cursor: !authToken ? 'not-allowed' : 'pointer'
                    }}
                    onClick={handleAddModule}
                    disabled={!authToken}
                >
                    + Add Module
                </button>
            </div>

            <div style={styles.tableContainer}>
                {loading && (
                    <div style={styles.loadingOverlay}>
                        <div>Saving changes...</div>
                    </div>
                )}
                <table style={styles.table}>
                    <thead style={styles.tableHeader}>
                        <tr>
                            <th style={{ ...styles.headerCell, width: '15%' }}>Category</th>
                            <th style={{ ...styles.headerCell, width: '20%' }}>Module / Order Type</th>
                            <th style={{ ...styles.headerCell, width: '25%' }}>Description</th>
                            <th style={{ ...styles.headerCell, width: '15%' }}>Select</th>
                            <th style={{ ...styles.headerCell, width: '12.5%' }}>Monthly (₹)</th>
                            <th style={{ ...styles.headerCell, ...styles.lastHeaderCell, width: '12.5%' }}>Yearly (₹)</th>
                            <th style={{ ...styles.headerCell, width: '12.5%' }}>Subscription Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modulesData.map((module) => (
                            <tr key={`${module.code}-${module.id}`}>
                                <td
                                    style={{
                                        ...styles.dataCell,
                                        ...styles.categoryCell
                                    }}
                                >
                                    {isEditing && authToken ? (
                                        <select
                                            value={
                                                editingModules[module.code]?.catageory ||
                                                module.apiCatageory ||
                                                'BASE_PLAN'
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'catageory',
                                                    e.target.value
                                                )
                                            }
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '2px solid #e2e8f0',
                                                fontSize: '0.95rem',
                                                fontWeight: '600',
                                                color: '#1e293b',
                                                backgroundColor: 'white'
                                            }}
                                        >
                                            {categoryOptions.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        module.category
                                    )}
                                </td>

                                <td style={styles.dataCell}>
                                    {isEditing && authToken ? (
                                        <input
                                            type="text"
                                            value={
                                                editingModules[module.code]?.name ||
                                                module.name
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'name',
                                                    e.target.value
                                                )
                                            }
                                            style={styles.moduleNameInput}
                                        />
                                    ) : (
                                        <div style={styles.moduleName}>
                                            {module.name}
                                        </div>
                                    )}
                                </td>

                                <td style={styles.dataCell}>
                                    {isEditing && authToken ? (
                                        <input
                                            type="text"
                                            value={
                                                editingModules[module.code]?.description ||
                                                module.description
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'description',
                                                    e.target.value
                                                )
                                            }
                                            style={styles.descriptionInput}
                                        />
                                    ) : (
                                        <div style={styles.moduleDescription}>
                                            {module.description}
                                        </div>
                                    )}
                                </td>

                                <td style={styles.statusCell}>
                                    {isEditing && authToken ? (
                                        <select
                                            value={
                                                editingModules[module.code]
                                                    ?.defaultIncluded ||
                                                module.defaultIncluded ||
                                                'INCLUDE'
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'defaultIncluded',
                                                    e.target.value
                                                )
                                            }
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                border: '2px solid #e2e8f0',
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                backgroundColor: 'white'
                                            }}
                                        >
                                            {defaultIncludedOptions.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        module.type === 'mandatory' ? (
                                            <div
                                                style={{
                                                    ...styles.badge,
                                                    ...styles.mandatoryBadge
                                                }}
                                            >
                                                Mandatory
                                            </div>
                                        ) : module.type === 'included' ? (
                                            <div
                                                style={{
                                                    ...styles.badge,
                                                    ...styles.includedBadge
                                                }}
                                            >
                                                Included
                                            </div>
                                        ) : module.type === 'exclude' ? (
                                            <div
                                                style={{
                                                    ...styles.badge,
                                                    background: '#fee2e2',
                                                    color: '#dc2626',
                                                    border: '1px solid #fecaca'
                                                }}
                                            >
                                                Exclude
                                            </div>
                                        ) : (
                                            module.type === 'toggle' && (
                                                <div style={styles.toggleContainer}>
                                                    <label style={styles.toggleSwitch}>
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                selectedModules[module.code] ||
                                                                false
                                                            }
                                                            onChange={() =>
                                                                handleModuleToggle(module.code)
                                                            }
                                                            style={styles.toggleInput}
                                                            disabled={!authToken}
                                                        />
                                                        <span
                                                            style={{
                                                                ...styles.toggleSlider,
                                                                ...(selectedModules[module.code]
                                                                    ? styles.checkedToggleSlider
                                                                    : {})
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    ...styles.toggleSliderBefore,
                                                                    ...(selectedModules[module.code]
                                                                        ? styles.checkedToggleSliderBefore
                                                                        : {})
                                                                }}
                                                            />
                                                        </span>
                                                    </label>

                                                    <div style={styles.toggleLabel}>
                                                        {selectedModules[module.code] ? (
                                                            <span
                                                                style={styles.includedText}
                                                            >
                                                                Include
                                                            </span>
                                                        ) : (
                                                            <span
                                                                style={styles.excludedText}
                                                            >
                                                                Exclude
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        )
                                    )}
                                </td>

                                {/* MONTHLY PRICE */}
                                <td style={styles.priceCell}>
                                    {isEditing && authToken ? (
                                        <input
                                            type="number"
                                            value={
                                                editingModules[module.code]
                                                    ?.monthlyPrice ||
                                                module.monthlyPrice
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'monthlyPrice',
                                                    e.target.value
                                                )
                                            }
                                            style={styles.priceInput}
                                            min="0"
                                            step="1"
                                        />
                                    ) : module.monthlyPrice > 0 ? (
                                        <div style={styles.priceDisplay}>
                                            ₹{module.monthlyPrice.toLocaleString()}
                                        </div>
                                    ) : module.type === 'included' ||
                                        module.type === 'mandatory' ? (
                                        <div style={styles.includedPrice}>
                                            Included
                                        </div>
                                    ) : (
                                        <div style={styles.priceDisplay}>₹0</div>
                                    )}
                                </td>

                                {/* YEARLY PRICE */}
                                <td style={styles.priceCell}>
                                    {isEditing && authToken ? (
                                        <input
                                            type="number"
                                            value={
                                                editingModules[module.code]
                                                    ?.yearlyPrice ||
                                                module.yearlyPrice
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'yearlyPrice',
                                                    e.target.value
                                                )
                                            }
                                            style={styles.priceInput}
                                            min="0"
                                            step="1"
                                        />
                                    ) : module.yearlyPrice > 0 ? (
                                        <div style={styles.priceDisplay}>
                                            ₹{module.yearlyPrice.toLocaleString()}
                                        </div>
                                    ) : module.type === 'included' ||
                                        module.type === 'mandatory' ? (
                                        <div style={styles.includedPrice}>
                                            Included
                                        </div>
                                    ) : (
                                        <div style={styles.priceDisplay}>₹0</div>
                                    )}
                                </td>

                                {/* ✅ SUBSCRIPTION PRICE */}
                                <td style={styles.priceCell}>
                                    {isEditing && authToken ? (
                                        <input
                                            type="number"
                                            value={
                                                editingModules[module.code]
                                                    ?.subscriptionPrice ||
                                                module.subscriptionPrice ||
                                                0
                                            }
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    module.code,
                                                    'subscriptionPrice',
                                                    e.target.value
                                                )
                                            }
                                            style={styles.priceInput}
                                            min="0"
                                            step="1"
                                        />
                                    ) : module.subscriptionPrice > 0 ? (
                                        <div style={styles.priceDisplay}>
                                            ₹{module.subscriptionPrice.toLocaleString()}
                                        </div>
                                    ) : module.type === 'included' ||
                                        module.type === 'mandatory' ? (
                                        <div style={styles.includedPrice}>
                                            Included
                                        </div>
                                    ) : (
                                        <div style={styles.priceDisplay}>₹0</div>
                                    )}
                                </td>
                            </tr>
                        ))}

                        {/* GRAND TOTAL ROW */}
                        <tr style={styles.grandTotalRow}>
                            <td
                                style={{
                                    ...styles.grandTotalCell,
                                    ...styles.grandTotalLabel
                                }}
                            >
                                Grand Total
                            </td>

                            <td style={styles.grandTotalCell}></td>
                            <td style={styles.grandTotalCell}></td>
                            <td style={styles.grandTotalCell}></td>

                            <td
                                style={{
                                    ...styles.grandTotalCell,
                                    ...styles.grandTotalAmount
                                }}
                            >
                                ₹{monthlyTotal.toLocaleString()}
                            </td>

                            <td
                                style={{
                                    ...styles.grandTotalCell,
                                    ...styles.grandTotalAmount
                                }}
                            >
                                ₹{yearlyTotal.toLocaleString()}
                            </td>

                            <td
                                style={{
                                    ...styles.grandTotalCell,
                                    ...styles.grandTotalAmount
                                }}
                            >
                                ₹{subscriptionTotal.toLocaleString()}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style={styles.tableFooter}>
                    <div style={styles.footerLeft}></div>
                    <div style={styles.footerRight}>
                        {!isEditing ? (
                            <button
                                style={{
                                    ...styles.editButton,
                                    opacity: !authToken ? 0.6 : 1,
                                    cursor: !authToken ? 'not-allowed' : 'pointer'
                                }}
                                onClick={handleEditClick}
                                disabled={!authToken}
                            >
                                Edit
                            </button>
                        ) : (
                            <div style={styles.saveCancelContainer}>
                                <button
                                    style={styles.cancelButton}
                                    onClick={() => setIsEditing(false)}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    style={styles.saveButton}
                                    onClick={handleSaveChanges}
                                    disabled={loading || !authToken}
                                >
                                    {loading ? 'Saving...' : 'Save Changes'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionTable;